import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { AppDownloadButton } from "./AppDownloadButton";
import { SectionHeading } from "./SectionHeading";
import { EASE } from "./Motion";

const AUDIENCES = [
  { name: "Independent Artists", copy: "Release, pitch and grow on your own terms — without waiting for permission." },
  { name: "Managers", copy: "Keep every artist's releases, pitches and campaigns in view from one phone." },
  { name: "Music Teams", copy: "Work from one shared picture of the release, the pitch and the results." },
  { name: "Labels", copy: "Run roster campaigns and read market signal across every release." },
];

export const ForArtists = () => (
  <section id="for-artists" data-testid="for-artists-section" className="border-t border-white/10">
    <div className="mx-auto max-w-[1400px] px-5 py-section-sm sm:px-8 lg:px-12 lg:py-section">
      <div className="grid gap-10 lg:grid-cols-12">
        <SectionHeading className="lg:col-span-8" eyebrow="For artists / 04" lines={["Built for artists", "who want", "more control."]} label="Built for artists who want more control." />
        <div className="self-end lg:col-span-4">
          <p className="text-base leading-relaxed text-pa-muted md:text-lg">
            Whether you&apos;re releasing your first single or building a global audience, Pitchally gives you the infrastructure to take more control of your career.
          </p>
          <AppDownloadButton label="Start building" source="for-artists" testId="for-artists-cta" className="mt-8" />
        </div>
      </div>
      <ul className="mt-16 border-t border-white/10 lg:mt-24">
        {AUDIENCES.map((a, i) => (
          <motion.li
            key={a.name}
            data-testid={`audience-${a.name.toLowerCase().replace(/\s+/g, "-")}`}
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.8, ease: EASE, delay: i * 0.07 }}
            className="group grid grid-cols-12 items-center gap-4 border-b border-white/10 py-7 lg:py-9"
          >
            <span className="col-span-2 font-mono text-xs text-pa-dim lg:col-span-1">0{i + 1}</span>
            <h3 className="col-span-10 font-display text-[clamp(2.2rem,5vw,4.5rem)] uppercase leading-none text-pa-ink transition-[transform,color] duration-500 ease-out-expo group-hover:translate-x-3 group-hover:text-pa-orange lg:col-span-6">
              {a.name}
            </h3>
            <p className="col-span-10 col-start-3 text-[15px] leading-relaxed text-pa-muted lg:col-span-4 lg:col-start-auto">{a.copy}</p>
            <ArrowRight className="hidden h-6 w-6 justify-self-end text-pa-dim transition-[transform,color] duration-500 ease-out-expo group-hover:-rotate-45 group-hover:text-pa-orange lg:col-span-1 lg:block" aria-hidden="true" />
          </motion.li>
        ))}
      </ul>
    </div>
  </section>
);
